'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./index-fccd5f88.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');
var LazyImage = require('./LazyImage-de3cf6f6.js');
require('./Image.module-e3b7ba64.js');
require('./index-72f7f45d.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".ContentBanner_module_visuallyHidden__28eb6f97 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.ContentBanner_module_youtubeVideo__28eb6f97 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.ContentBanner_module_ContentBanner__28eb6f97 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  position: relative;\n  height: auto;\n}\n.ContentBanner_module_ContentBanner__28eb6f97 .ContentBanner_module_Content__28eb6f97 {\n  max-width: 980px;\n  padding: 54px 24px;\n  position: relative;\n}\n.ContentBanner_module_ContentBanner__28eb6f97 .ContentBanner_module_Content__28eb6f97 * {\n  color: #ffffff;\n}\n.ContentBanner_module_ContentBanner__28eb6f97 .ContentBanner_module_ContentImage__28eb6f97 {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  object-fit: cover;\n}\n.ContentBanner_module_ContentBanner__28eb6f97 .ContentBanner_module_ContentImage__28eb6f97.ContentBanner_module_Overlay__28eb6f97 {\n  filter: brightness(0.4);\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Templates/Section/ContentBanner.module.scss");
var modules_851af420 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"ContentBanner_module_visuallyHidden__28eb6f97","youtubeVideo":"ContentBanner_module_youtubeVideo__28eb6f97","ContentBanner":"ContentBanner_module_ContentBanner__28eb6f97","Content":"ContentBanner_module_Content__28eb6f97","ContentImage":"ContentBanner_module_ContentImage__28eb6f97","Overlay":"ContentBanner_module_Overlay__28eb6f97"};

function ContentBanner(_ref) {
  var children = _ref.children,
    backgroundColor = _ref.backgroundColor,
    imgSrc = _ref.imgSrc,
    imgAlt = _ref.imgAlt,
    id = _ref.id,
    _ref$overlay = _ref.overlay,
    overlay = _ref$overlay === void 0 ? true : _ref$overlay,
    height = _ref.height,
    defaultImg = _ref.defaultImg,
    extraClass = _ref.extraClass,
    loading = _ref.loading;
  return /*#__PURE__*/React__default["default"].createElement("section", {
    className: [modules_851af420.ContentBanner, extraClass ? extraClass : null].join(" "),
    style: {
      backgroundColor: backgroundColor,
      minHeight: height || "auto",
      height: "auto"
    }
  }, imgSrc ? /*#__PURE__*/React__default["default"].createElement(LazyImage.LazyImage, {
    src: imgSrc,
    id: id,
    extraClass: [modules_851af420.ContentImage, overlay ? modules_851af420.Overlay : null].join(" "),
    alt: imgAlt,
    objectFit: "cover",
    defaultImg: defaultImg,
    loading: loading
  }) : null, children ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_851af420.Content
  }, children) : null);
}
ContentBanner.propTypes = {
  extraClass: index.propTypes.exports.string,
  height: index.propTypes.exports.string,
  backgroundColor: index.propTypes.exports.string,
  imgSrc: index.propTypes.exports.string,
  id: index.propTypes.exports.string,
  defaultImg: index.propTypes.exports.string,
  imgAlt: index.propTypes.exports.string,
  overlay: index.propTypes.exports.bool,
  centerAlignContent: index.propTypes.exports.bool,
  rightAlignContent: index.propTypes.exports.bool,
  loading: index.propTypes.exports.oneOf(["lazy", "eager"])
};

exports.ContentBanner = ContentBanner;
